import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import '../resources/css/Arts.css'
import artsData from '../localhostDB/ArtsDB.json';
import InnerBannerSportsImg from '../resources/images/art-home-Cover.jpg';
import InnerBanner from './components/Banner/InnerBanner';
import entertainmentAbout from '../resources/images/entertainment_about_01.jpg';
import LetsConnectForm from '../components/LetsConnectForm';
import SingleBar from '../components/SingleBar';


const Arts: React.FC = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);
    return (
        <>
            <div id="artsBanner">
                <InnerBanner
                    bannerTitle="Discover a New"
                    bannerTitleSubLine="Arts World"
                    bannerText=" "
                    bannerLinkText="Coming Soon"
                    bannerLink="https://www.google.com/"
                    bannerImg={InnerBannerSportsImg}
                    themeClass="artsBannerTop"
                    bannerPageName="arts"
                />
            </div>
            <section className='aboutText aboutUsArts' id="artsAboutUs">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-4 my-3" data-aos="fade-up">
                            <div className="OurPartnersLogoImgInner">
                                <img src={entertainmentAbout} className='img-fluid' alt="About Cosmos" />
                            </div>
                        </div>
                        <div className="col-md-1"></div>
                        <div className="col-md-7 my-3" data-aos="fade-up">
                            <div className='sectionHeader whiteLine lineLeft'>
                                <h2>About Cosmos Arts</h2>
                            </div>
                            <div className="aboutTextInner">
                                <p>Cosmos Entertainment was founded in 2019 and is headquartered in Riyadh, Saudi Arabia. We specialize in acquiring exclusive and unique international intellectual properties (IPs) to bring world-class entertainment, events, and immersive experiences to the Kingdom of Saudi Arabia.</p>
                                <p>Our diverse portfolio includes globally acclaimed immersive experiences, art installations, edutainment exhibitions, Michelin-starred culinary events, and high-profile international acts, such as US magician Criss Angel, alongside a variety of family-friendly theatrical performances.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="artsServices" id="artsServices">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 mx-auto">
                            <div className="text-center">
                                <div className="sectionHeader yellowLine" data-aos="fade-up" data-aos-delay="100">
                                    <h2>Our Services</h2>
                                </div>
                                <p data-aos="fade-up" data-aos-delay="200">Cosmos Entertainment is experienced in partnering with International IPs for securing, delivering and executing the event in the Kingdom.</p>
                            </div>
                        </div>
                        <div className='clearfix'></div>
                    </div>
                    <div className="ServicesListArts">
                        <div className="row gx-5">
                            <div className="col-lg-3 col-md-6 my-3" data-aos="fade-up" data-aos-delay="300">
                                <div className="ServicesListBoxArts oneLine">
                                    <h3>Events</h3>
                                    <ul>
                                        <li>Acquire IP Rights Exclusively</li>
                                        <li>Secure Local Entity Interest</li>
                                        <li>360° Project Planning</li>
                                        <li>Arrange Local Permits/Licenses</li>
                                        <li>Local Project Management</li>
                                        <li>On-site Operations</li>
                                        <li>Marketing Strategies</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 my-3" data-aos="fade-up" data-aos-delay="400">
                                <div className="ServicesListBoxArts twoLine">
                                    <h3>Exhibitions</h3>
                                    <ul>
                                        <li>Acquire IP Rights Exclusively</li>
                                        <li>Secure Local Entity Interest</li>
                                        <li>360° Project Planning</li>
                                        <li>Arrange Local Permits/Licenses</li>
                                        <li>Local Project Management</li>
                                        <li>On-site Operations</li>
                                        <li>Marketing Strategies</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 my-3" data-aos="fade-up" data-aos-delay="500">
                                <div className="ServicesListBoxArts threeLine">
                                    <h3>Activations</h3>
                                    <ul>
                                        <li>Create New Concepts</li>
                                        <li>Develop Propositions</li>
                                        <li>Manage Execution & Logistics</li>
                                        <li>Handle Operations</li>
                                        <li>Marketing Strategies</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 my-3" data-aos="fade-up" data-aos-delay="600">
                                <div className="ServicesListBoxArts fourLine">
                                    <h3>Content Creation</h3>
                                    <ul>
                                        <li>Our creative team can create and produce new experiences utilising our International best-in-class partners and technologies with local content and talent.</li>
                                        <li>Creating unique, Saudi-themed cultural and pertinent concepts for entertainment activations locally and internationally.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='OurPortfolio' id="artsPortfolio">
                <div className="artsPage">
                    <div className="container">
                        <div className="col-md-8 mx-auto">
                            <div className="text-center">
                                <div className="sectionHeader yellowLine" data-aos="fade-up" data-aos-delay="100">
                                    <h2>Our Portfolio</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        {artsData.ArtsText.map((item, index) => (
                            <div className="col-12 col-sm-6 col-lg-4 p-0" data-aos="zoom-in-up" data-aos-delay="300" key={index}>
                                <div className="portfolio-thumb effect-3 Arts">
                                    <div className="effect-img">
                                        <img src={item.portfolioThumb} alt={item.portfolioName} />
                                    </div>
                                    <div className="portfolioOverlayBox effect-text">
                                        <div className="portfolioTet">
                                            <h2>{item.portfolioName}</h2>
                                            <p>{item.portfolioText}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <SingleBar />
            <div id="artsContactUs">
                {/* <LetsConnectForm
                    letsConnectText="If your product, service or event is unique, innovative and best-in-class, then please reach out to us using the contact form below, and one of our team members will get back to you shortly!"
                    formLineCl="yellowLine"
                /> */}
            </div>
        </>
    )
}

export default Arts
